/**************************************************************************
 *                                                                        *
 *                 GENERATED FILE - DO NOT MODIFY!                        *
 *                                                                        *
 *                 Update API models in API project, then                 *
 *                 regenerate with the SwaggerToTypescript tool                    *
 *                                                                        *
 **************************************************************************/

import { CufiAdminApi } from "@app/core/api/base/CufiAdminApi";
import { PagedApiResponse } from "@app/core/api/base/PagedApiResponse";
import { ApiResponse } from "@app/core/api/base/ApiResponse";
import { Observable } from "rxjs";
import { Injectable, Inject, Optional, InjectionToken } from "@angular/core";
import { UserSummaryDto } from "@app/core/api/models/UserSummaryDto";
import { UserDto } from "@app/core/api/models/UserDto";
import { CreateUserParameters } from "@app/core/api/models/CreateUserParameters";
import { UpdateUserParameters } from "@app/core/api/models/UpdateUserParameters";

@Injectable({
  providedIn: "root",
})
export class UsersApiService {
  private api: CufiAdminApi;

  constructor(@Inject(CufiAdminApi) api: CufiAdminApi) {
    this.api = api;
  }

  public GetUsers(
    request: GetUsersRequest,
  ): Observable<PagedApiResponse<Array<UserSummaryDto>>> {
    return this.api.GetApiCall<PagedApiResponse<Array<UserSummaryDto>>>(
      "/v1/users",
      200,
      request.path,
      request.query,
    );
  }

  public CreateUser(request: CreateUserRequest): Observable<UserDto> {
    return this.api.PostApiCall<UserDto, any>(
      "/v1/users",
      200,
      request.path,
      request.query,
      request.body,
    );
  }

  public GetUser(request: GetUserRequest): Observable<UserDto> {
    return this.api.GetApiCall<UserDto>(
      "/v1/users/{id}",
      200,
      request.path,
      request.query,
    );
  }

  public UpdateUser(request: UpdateUserRequest): Observable<UserDto> {
    return this.api.PostApiCall<UserDto, any>(
      "/v1/users/{id}",
      200,
      request.path,
      request.query,
      request.body,
    );
  }

  public DeleteUser(request: DeleteUserRequest): Observable<string> {
    return this.api.DeleteApiCallWithReturnType<string>(
      "/v1/users/{id}",
      204,
      request.path,
      request.query,
    );
  }

  public GetCurrentUser(request: GetCurrentUserRequest): Observable<void> {
    return this.api.GetApiCall<void>(
      "/v1/users/me",
      200,
      request.path,
      request.query,
    );
  }
}

export interface GetUsersRequestQuery {
  sortBy?: string[];
  search?: string;
  pageNumber?: number;
  pageSize?: number;
  firstName?: string;
  lastName?: string;
  isActive?: boolean;
}

export interface GetUsersRequest {
  path?: void;
  query: GetUsersRequestQuery;
  body?: void;
}

export interface CreateUserRequest {
  path?: void;
  query?: void;
  body: CreateUserParameters;
}

export interface GetUserRequestPath {
  id: number;
}

export interface GetUserRequest {
  path: GetUserRequestPath;
  query?: void;
  body?: void;
}

export interface UpdateUserRequestPath {
  id: number;
}

export interface UpdateUserRequest {
  path: UpdateUserRequestPath;
  query?: void;
  body: UpdateUserParameters;
}

export interface DeleteUserRequestPath {
  id: number;
}

export interface DeleteUserRequest {
  path: DeleteUserRequestPath;
  query?: void;
  body?: void;
}

export interface GetCurrentUserRequest {
  path?: void;
  query?: void;
  body?: void;
}
